import { useEffect, type ReactNode } from 'react'
import { useUiStore } from '@/stores/uiStore'
import LandingFooter from './LandingFooter'
import LandingNav from './LandingNav'

export default function MarketingLayout({ children }: { children: ReactNode }) {
  useEffect(() => {
    document.documentElement.classList.add('dark')
    return () => {
      const { theme } = useUiStore.getState()
      if (theme === 'light') {
        document.documentElement.classList.remove('dark')
      }
    }
  }, [])

  return (
    <div className="flex min-h-screen flex-col bg-[#08080f] font-body text-white">
      <LandingNav solidNav />
      <main className="relative isolate z-0 flex-1 bg-transparent pt-14 sm:pt-16">{children}</main>
      <div className="relative z-10">
        <LandingFooter />
      </div>
    </div>
  )
}
